module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/enterprise_header.c8dee4ba.png";